import { Component, OnDestroy, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslocoService } from '@ngneat/transloco';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-data-protiction',
  templateUrl: './data-protiction.component.html',
  styleUrls: ['./data-protiction.component.scss']
})
export class DataProtictionComponent implements OnInit, OnDestroy {
  activeLang: string = 'EN';
  private langChangesSubscription: Subscription;
  constructor(private _translocoService: TranslocoService, private title: Title) { }

  ngOnInit(): void {
    this.title.setTitle('Data-protiction')
    this.langChangesSubscription = this._translocoService.langChanges$.subscribe((activeLang) => {
      this.activeLang = activeLang;
    });
  }

  ngOnDestroy(): void {
    if (this.langChangesSubscription) {
      this.langChangesSubscription.unsubscribe();
    }
  }
}
